import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';
import axios from '../../custom-axios';

const FeatureFlagContext = createContext();

export const FeatureFlagProvider = ({ children }) => {
  const [flags, setFlags] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const getFeatureFlags = async () => {
      setLoading(true);
      try {
        const response = await axios.processGet(`${process.env.REACT_APP_API_CUSTOMER_URL}/FeatureFlag`);
        const quoteWidgetFlags = Object.entries(response.data)
          .filter(([key]) => key.startsWith('QuoteWidget'))
          .reduce((p, [k, v]) => ({ ...p, [k]: v }), {});
        setFlags(quoteWidgetFlags)
      } catch (e) {
        setFlags({});
      } finally {
        setLoading(false);
      }
    };
    getFeatureFlags();
  }, []);

  return (
    <FeatureFlagContext.Provider value={flags}>
      {loading ? 'Loading...' : null}
      {children}
    </FeatureFlagContext.Provider>
  );
}

const useFeatureFlag = (featureKey) => {
  const context = useContext(FeatureFlagContext);
  if (!context) {
    throw Error('Feature Flag Context not found');
  }

  const featureFlags = context;
  const featureFlag = useMemo(
    () => !!featureFlags[featureKey],
    [featureFlags, featureKey],
  );
  return featureFlag;
};

const useMCPBeacon = () => useFeatureFlag('QuoteWidgetMCPBeacon');

export { useMCPBeacon };
